"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Size;

(function (Size) {
  Size[Size["Auto"] = 0] = "Auto";
  Size[Size["Stretch"] = 1] = "Stretch";
  Size[Size["Small"] = 2] = "Small";
  Size[Size["Medium"] = 3] = "Medium";
  Size[Size["Large"] = 4] = "Large";
})(Size = exports.Size || (exports.Size = {}));

var SizeUnit;

(function (SizeUnit) {
  SizeUnit[SizeUnit["Weight"] = 0] = "Weight";
  SizeUnit[SizeUnit["Pixel"] = 1] = "Pixel";
})(SizeUnit = exports.SizeUnit || (exports.SizeUnit = {}));

var TextSize;

(function (TextSize) {
  TextSize[TextSize["Small"] = 0] = "Small";
  TextSize[TextSize["Default"] = 1] = "Default";
  TextSize[TextSize["Medium"] = 2] = "Medium";
  TextSize[TextSize["Large"] = 3] = "Large";
  TextSize[TextSize["ExtraLarge"] = 4] = "ExtraLarge";
})(TextSize = exports.TextSize || (exports.TextSize = {}));

var Spacing;

(function (Spacing) {
  Spacing[Spacing["None"] = 0] = "None";
  Spacing[Spacing["Small"] = 1] = "Small";
  Spacing[Spacing["Default"] = 2] = "Default";
  Spacing[Spacing["Medium"] = 3] = "Medium";
  Spacing[Spacing["Large"] = 4] = "Large";
  Spacing[Spacing["ExtraLarge"] = 5] = "ExtraLarge";
  Spacing[Spacing["Padding"] = 6] = "Padding";
})(Spacing = exports.Spacing || (exports.Spacing = {}));

var TextWeight;

(function (TextWeight) {
  TextWeight[TextWeight["Lighter"] = 0] = "Lighter";
  TextWeight[TextWeight["Default"] = 1] = "Default";
  TextWeight[TextWeight["Bolder"] = 2] = "Bolder";
})(TextWeight = exports.TextWeight || (exports.TextWeight = {}));

var TextColor;

(function (TextColor) {
  TextColor[TextColor["Default"] = 0] = "Default";
  TextColor[TextColor["Dark"] = 1] = "Dark";
  TextColor[TextColor["Light"] = 2] = "Light";
  TextColor[TextColor["Accent"] = 3] = "Accent";
  TextColor[TextColor["Good"] = 4] = "Good";
  TextColor[TextColor["Warning"] = 5] = "Warning";
  TextColor[TextColor["Attention"] = 6] = "Attention";
})(TextColor = exports.TextColor || (exports.TextColor = {}));

var HorizontalAlignment;

(function (HorizontalAlignment) {
  HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
  HorizontalAlignment[HorizontalAlignment["Center"] = 1] = "Center";
  HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})(HorizontalAlignment = exports.HorizontalAlignment || (exports.HorizontalAlignment = {}));

var VerticalAlignment;

(function (VerticalAlignment) {
  VerticalAlignment[VerticalAlignment["Top"] = 0] = "Top";
  VerticalAlignment[VerticalAlignment["Center"] = 1] = "Center";
  VerticalAlignment[VerticalAlignment["Bottom"] = 2] = "Bottom";
})(VerticalAlignment = exports.VerticalAlignment || (exports.VerticalAlignment = {}));

var ActionAlignment;

(function (ActionAlignment) {
  ActionAlignment[ActionAlignment["Left"] = 0] = "Left";
  ActionAlignment[ActionAlignment["Center"] = 1] = "Center";
  ActionAlignment[ActionAlignment["Right"] = 2] = "Right";
  ActionAlignment[ActionAlignment["Stretch"] = 3] = "Stretch";
})(ActionAlignment = exports.ActionAlignment || (exports.ActionAlignment = {}));

var ImageStyle;

(function (ImageStyle) {
  ImageStyle[ImageStyle["Default"] = 0] = "Default";
  ImageStyle[ImageStyle["Person"] = 1] = "Person";
})(ImageStyle = exports.ImageStyle || (exports.ImageStyle = {}));

var ShowCardActionMode;

(function (ShowCardActionMode) {
  ShowCardActionMode[ShowCardActionMode["Inline"] = 0] = "Inline";
  ShowCardActionMode[ShowCardActionMode["Popup"] = 1] = "Popup";
})(ShowCardActionMode = exports.ShowCardActionMode || (exports.ShowCardActionMode = {}));

var Orientation;

(function (Orientation) {
  Orientation[Orientation["Horizontal"] = 0] = "Horizontal";
  Orientation[Orientation["Vertical"] = 1] = "Vertical";
})(Orientation = exports.Orientation || (exports.Orientation = {}));

var BackgroundImageMode;

(function (BackgroundImageMode) {
  BackgroundImageMode[BackgroundImageMode["Stretch"] = 0] = "Stretch";
  BackgroundImageMode[BackgroundImageMode["RepeatHorizontally"] = 1] = "RepeatHorizontally";
  BackgroundImageMode[BackgroundImageMode["RepeatVertically"] = 2] = "RepeatVertically";
  BackgroundImageMode[BackgroundImageMode["Repeat"] = 3] = "Repeat";
})(BackgroundImageMode = exports.BackgroundImageMode || (exports.BackgroundImageMode = {}));

var ActionIconPlacement;

(function (ActionIconPlacement) {
  ActionIconPlacement[ActionIconPlacement["LeftOfTitle"] = 0] = "LeftOfTitle";
  ActionIconPlacement[ActionIconPlacement["AboveTitle"] = 1] = "AboveTitle";
})(ActionIconPlacement = exports.ActionIconPlacement || (exports.ActionIconPlacement = {}));

var InputTextStyle;

(function (InputTextStyle) {
  InputTextStyle[InputTextStyle["Text"] = 0] = "Text";
  InputTextStyle[InputTextStyle["Tel"] = 1] = "Tel";
  InputTextStyle[InputTextStyle["Url"] = 2] = "Url";
  InputTextStyle[InputTextStyle["Email"] = 3] = "Email";
})(InputTextStyle = exports.InputTextStyle || (exports.InputTextStyle = {}));
/*
    This should really be a string enum, e.g.

        export enum ContainerStyle {
            Default = "default",
            Emphasis = "emphasis"
        }

    However, some hosts do not use a version of TypeScript
    recent enough to understand string enums. This is
    a compatible construct that does not require using
    a more recent version of TypeScript.
*/


var ContainerStyle =
/** @class */
function () {
  function ContainerStyle() {}

  ContainerStyle.Default = "default";
  ContainerStyle.Emphasis = "emphasis";
  return ContainerStyle;
}();

exports.ContainerStyle = ContainerStyle;
var ValidationError;

(function (ValidationError) {
  ValidationError[ValidationError["Hint"] = 0] = "Hint";
  ValidationError[ValidationError["ActionTypeNotAllowed"] = 1] = "ActionTypeNotAllowed";
  ValidationError[ValidationError["CollectionCantBeEmpty"] = 2] = "CollectionCantBeEmpty";
  ValidationError[ValidationError["Deprecated"] = 3] = "Deprecated";
  ValidationError[ValidationError["ElementTypeNotAllowed"] = 4] = "ElementTypeNotAllowed";
  ValidationError[ValidationError["InteractivityNotAllowed"] = 5] = "InteractivityNotAllowed";
  ValidationError[ValidationError["InvalidPropertyValue"] = 6] = "InvalidPropertyValue";
  ValidationError[ValidationError["MissingCardType"] = 7] = "MissingCardType";
  ValidationError[ValidationError["PropertyCantBeNull"] = 8] = "PropertyCantBeNull";
  ValidationError[ValidationError["TooManyActions"] = 9] = "TooManyActions";
  ValidationError[ValidationError["UnknownActionType"] = 10] = "UnknownActionType";
  ValidationError[ValidationError["UnknownElementType"] = 11] = "UnknownElementType";
  ValidationError[ValidationError["UnsupportedCardVersion"] = 12] = "UnsupportedCardVersion";
})(ValidationError = exports.ValidationError || (exports.ValidationError = {}));

var ContainerFitStatus;

(function (ContainerFitStatus) {
  ContainerFitStatus[ContainerFitStatus["FullyInContainer"] = 0] = "FullyInContainer";
  ContainerFitStatus[ContainerFitStatus["Overflowing"] = 1] = "Overflowing";
  ContainerFitStatus[ContainerFitStatus["FullyOutOfContainer"] = 2] = "FullyOutOfContainer";
})(ContainerFitStatus = exports.ContainerFitStatus || (exports.ContainerFitStatus = {}));